import * as THREE from 'three';

export class ExplodeAnimation {
	constructor(x, y, sceneRef) {
		this.status = true;
		this.dirs = [];
		let movementSpeed = 0.6;
		this.particles = 140;
		this.geometry = new THREE.BufferGeometry();
		var colors = [0xff0fff, 0xccff00, 0xff000f, 0x996600, 0xffffff];
		this.blacklisted = false;
		let arr = new Float32Array(this.particles * 3);
		this.colorTrans = 0;
		this.fromColor = new THREE.Color(0x00f8ff);
		this.toColor = new THREE.Color(0xff0fff);

		for (let i = 0; i < this.particles; i++) {
			let pos = i * 3;

			arr[pos] = x;
			arr[pos + 1] = 0;
			arr[pos + 2] = y;

			this.dirs.push({
				x: Math.random() * movementSpeed - movementSpeed / 2,
				y: Math.random() * movementSpeed - movementSpeed / 2,
				z: Math.random() * movementSpeed - movementSpeed / 2,
			});
		}

		//this.geometry.setAttribute('position', new THREE.BufferAttribute(this.getRandomParticelPos(this.particles), 3));
		this.geometry.setAttribute('position', new THREE.BufferAttribute(arr, 3));

		this.material = new THREE.PointsMaterial({
			size: 0.2,
			blending: THREE.AdditiveBlending,
			transparent: true,
			depthTest: false,
			opacity: 1,
		});

		let particles = new THREE.Points(this.geometry, this.material);

		this.object = particles;
		//this.status = true;

		//this.xDir = Math.random() * movementSpeed - movementSpeed / 2;
		//this.yDir = Math.random() * movementSpeed - movementSpeed / 2;
		//this.zDir = Math.random() * movementSpeed - movementSpeed / 2;

		sceneRef.add(this.object);

		return this;
	}

	getRandomParticelPos = (particleCount) => {
		const arr = new Float32Array(particleCount * 3);

		for (let i = 0; i < particleCount * 3; i++) {
			arr[i] = 0;
		}

		return arr;
	};

	update() {
		if (this.status == true) {
			let positions = this.object.geometry.attributes.position.array;

			for (let i = 0; i < this.particles; i++) {
				let pos = i * 3;
				positions[pos] += this.dirs[i].x;
				positions[pos + 1] += this.dirs[i].y;
				positions[pos + 2] += this.dirs[i].z;

				this.material.opacity -= 0.000035;

				this.colorTrans += 0.0001;
				this.material.color.copy(this.fromColor).lerpHSL(this.toColor, this.colorTrans);

				if (this.material.opacity <= 0) this.blacklisted = true;
			}

			this.object.geometry.attributes.position.needsUpdate = true;
		}
	}

	reset() {
		this.blacklisted = false;
	}
}
